import { useContext } from 'react';
import { Box, Theme, useTheme } from '@mui/material';
import { ReactComponent as CarbonTargetIcon } from '../../assets/icons/Target.svg';
import ConfigurationWrapper from '../../components/shared/ConfigurationWrapper';
import PanelCarbonTargets from '../../components/configuration/carbon_targets/PanelCarbonTargets';
import { useModuleDurationTracking } from '../../hooks/useModuleDurationTracking';
import { GroupContext } from '../../context/GroupContext';
import { CompanyContext } from '../../context/CompanyContext';

const ConfigurationCarbonTargets = () => {
  const { group } = useContext(GroupContext);
  const { company } = useContext(CompanyContext);

  if (!group || !company) return null;

  // Track module duration.
  useModuleDurationTracking('Configuration', 'Carbon Targets', group.id, company.id);

  const theme: Theme = useTheme();
  const primary_blue: string = theme.palette.primary.main;
  return (
    <Box>
      <ConfigurationWrapper
        title="Carbon Targets"
        icon={<CarbonTargetIcon height={50} fill={primary_blue} stroke={primary_blue} />}
        previous={null}
        next={null}
      >
        <PanelCarbonTargets />
      </ConfigurationWrapper>
    </Box>
  );
};

export default ConfigurationCarbonTargets;
